import { createGetEndpoint } from '@sonar-software/sonar-http';
import { RecommendedActionTemplateDetails } from '@types';

export type GetRecommendedActionTemplateByIdRequest = {
	templateId: number;
};

export const getRecommendedActionTemplateById =
	createGetEndpoint<GetRecommendedActionTemplateByIdRequest, RecommendedActionTemplateDetails>(
		(request) => `/api/v3/recommended-actions/templates/${request.templateId}/`
	);
